import type { CustomerConfig } from "../customer.model";


/** The generic demo: this project's own components, no customer content. */
export const DEMO_CUSTOMER: CustomerConfig = {
  id: "demo",
  landing: [
    () => import("../../pages/landing-page/components/banner/banner.component").then((m) => m.BannerComponent),
    () => import("../../pages/landing-page/components/introduce/introduce.component").then((m) => m.IntroduceComponent),
    () => import("../../pages/landing-page/components/course-categories/course-categories.component").then((m) => m.CourseCategoriesComponent),
    () => import("../../pages/landing-page/components/courses/courses.component").then((m) => m.CoursesComponent),
    () => import("../../pages/landing-page/components/testimonials/testimonials.component").then((m) => m.TestimonialsComponent),
    () => import("../../pages/landing-page/components/footer-landing/footer-landing.component").then((m) => m.FooterLandingComponent),
  ],
  aboutUs: [
    () => import("../../pages/about-us/components/about/about.component").then((m) => m.AboutComponent),
    () => import("../../pages/about-us/components/teacher/teacher.component").then((m) => m.TeacherComponent),
  ],
};
